module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crt",
    attrs: {
      "id": "pz2-1"
    }
  }, [_vm._v("Text Copyright © 2013 Dr. Beverly Ann Browning ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "pz2-2"
    }
  }, [_vm._v("\n\t\t\t\t\tAll rights reserved. No part of this book may be reproduced or transmitted in any\n\t\t\t\t\tform or by any means, electronic or mechanical, including photocopying, recording,\n\t\t\t\t\tor by any information storage and retrieval system, without permission in writing\n\t\t\t\t\tfrom publisher. ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "pz2-7"
    }
  }, [_vm._v("\n\t\t\t\t\tPublished by: ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-style": "hidden"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top",
      "text-align": "center",
      "border-style": "hidden"
    }
  }, [_vm._v("WriteLife")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top",
      "border-style": "hidden",
      "text-align": "center"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tRule of Thumb ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top",
      "text-align": "center",
      "border-style": "hidden"
    }
  }, [_vm._v("(An imprint of Boutique of Quality Books Publishing Company)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "border-style": "hidden"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.ruleofthumbbiz.com",
      "id": "A5CL",
      "target": "_blank"
    }
  }, [_vm._v("www.ruleofthumbbiz.com")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-z2-4-4"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "border-style": "hidden"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.writelife.com",
      "id": "AL6",
      "target": "_blank"
    }
  }, [_vm._v("www.writelife.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top",
      "text-align": "center",
      "border-style": "hidden"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "pz2-13"
    }
  }, [_vm._v("\n\t\t\t\t\tPrinted in the United States of America ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "pz2-14"
    }
  }, [_vm._v("\n\t\t\t\t\tISBN 978-1-60808-053-3 ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    staticStyle: {
      "margin-top": "-1.9em"
    },
    attrs: {
      "id": "pz2-15"
    }
  }, [_vm._v("\n\t\t\t\t\tISBN 978-1-60808-016-8 ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "pz2-16"
    }
  }, [_vm._v("\n\t\t\t\t\tFirst Edition ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a70f58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage.vue
// module id = 60
// module chunks = 0